<template>
    <div class="pa-2">
        <v-row class="d-flex align-center justify-space-between">
            <v-col cols>
                <h1>Extensions</h1>
            </v-col>
            <v-col class="pl-2">
                <v-btn-primary id="Senario" @click="dialog = true">Ajouter</v-btn-primary>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" v-for="(ext, index) of extensions" :key="`extension-${ext.id}`">
                <ExtensionTableItem v-bind="ext" @removed="removeExtension" />
            </v-col>
        </v-row>
        <div style="width: 100%">
            <oss-dialog
                v-model="dialog"
                title="Ajouter une extension"
                :actions="dialogAction"
                @close="resetSelectedExtension"
            >
                <ExtensionItemEdition
                    :actions="dialogAction"
                    v-bind.sync="selectedExtension"
                    @updated="updateExtensionItem"
                />
            </oss-dialog>
        </div>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import EXTENSIONS from "@/graphql/extension/Extensions.gql";
import DELETE_EXTENSION from "@/graphql/extension/DeleteExtension.gql";

import ExtensionItemEdition from "./ExtensionItemEdition.vue";
import ExtensionTableItem from "./ExtensionTableItem.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        ExtensionItemEdition,
        ExtensionTableItem,
    },
})
export class ExtensionsTable extends Vue {
    selectedExtension: any = {
        id: "",
        name: "",
        url: "",
        type: "",
        displayIn: "",
    };

    dialog: boolean = false;

    dialogAction = {
        action: {
            title: "",
            function: () => {},
            display: true,
            disabled: false,
        },
    };

    @Apollo(
        {
            query: EXTENSIONS,
        },
        (data) => data.getExtensions,
    )
    extensions: any = null;

    resetSelectedExtension() {
        this.selectedExtension = {
            id: "",
            name: "",
            url: "",
            type: "",
            displayIn: "",
        };
    }

    async removeExtension({ id }: { id: string }) {
        if (!id) {
            return;
        }
        this.extensions = this.extensions.filter((ext: any) => ext.id !== id);
    }

    updateExtensionItem() {
        this.dialog = false;
    }
}

export default toNative(ExtensionsTable);
</script>
